import './assets/reset.css'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import deepmerge from 'deepmerge'
import LZString from 'lz-string'

//Firebase
import Firebase from 'firebase/app'
import "firebase/auth"
import "firebase/database"
var config = {
  apiKey: "AIzaSyCpuz4ekRk0gNXy2j6cbK0bm-LUGh9T01c",
  authDomain: "brickfinder.firebaseapp.com",
  databaseURL: "https://brickfinder.firebaseio.com",
  projectId: "firebase-brickfinder",
  storageBucket: "firebase-brickfinder.appspot.com",
  messagingSenderId: "914932626677"
};
const version = "13";
Firebase.initializeApp(config);
Vue.prototype.$Firebase = Firebase;
var UserRef = null;
Vue.prototype.$UserRef = UserRef

//FirebaseUI
import FirebaseUI from 'firebaseui'
import 'firebaseui/dist/firebaseui.css';
Vue.prototype.$AuthUI = new firebaseui.auth.AuthUI(Firebase.auth())


//Keen UI
import './assets/keenreset.css'
import 'keen-ui/dist/keen-ui.css';
import KeenUI from 'keen-ui';
Vue.use(KeenUI);

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  data: {
    loading: 0,
    username: null,
    userpic: null,
    title: "",
    sets: {},
    search: null,
    sort: null
  },
  template: '<App/>',
  methods: {},
  created() {

    // Clean Local Storage
    Object.keys(localStorage).filter(key => /^v\d+_/.test(key) && key.substr(1, 2) != version).forEach((key) => {
      localStorage.removeItem(key)
    })

    // Handle Bindings on Login
    this.$Firebase.auth().onAuthStateChanged(user => {
      var vue = this;
      if (user) {
        // User is signed in.
        this.username = user.displayName;
        this.userpic = user.photoURL;

        // Redirect if already logged in
        if (this.$route.name == "Login") {
          this.$router.push({
            name: 'Sets'
          });
        }

        let queue = Promise.resolve()

        // Change this to Vue.$UserRef maybe
        this.$UserRef = this.$Firebase.database().ref("users/" + user.uid)

        this.$UserRef.child("sets").on('child_added', function (snapshot) {

          var key = snapshot.key;
          var snap = snapshot.val();

          // Add Placeholder
          Vue.set(vue.sets, key, merge({
            set_num: key,
            name: "Loading",
            parts: {},
            found: 0,
            quantity: 1,
            remaining: 1,
            completeness: 0
          }, snap));

          // Get full set data first
          vue.loading++;
          queue = queue.then(() => load(key)).then(set => {
            console.debug('set loaded', key);
            // Add snapshot data
            vue.loading--;
            Vue.set(vue.sets, key, merge(set, snap));
            return Promise.resolve()
          }, error => {
            vue.loading--;
            console.warn(error)
            // Automatically delete invalid sets
            //vue.$UserRef.child('sets').child(snapshot.key).remove()
            return Promise.resolve()
          })
        })

        this.$UserRef.child("sets").on('child_changed', function (snapshot) {
          // Recursively and carefully add only the part found values.
          var key = snapshot.key;
          var snap = snapshot.val();
          Vue.set(vue.sets, key, merge(vue.sets[key], snap));
        });

        this.$UserRef.child("sets").on('child_removed', function (snapshot) {
          console.debug('set removed');
          vue.$delete(vue.sets, snapshot.key);
        });

      } else {
        // Logged Out
        this.$router.push({
          name: 'Login',
          query: {
            mode: 'select',
            signInSuccessUrl: this.$route.path
          }
        });
      }
    })
  }
})


function merge(set, snap) {
  set.found = 0;
  set.quantity = 0;

  // Add dynamic data from Firebase
  set = deepmerge(set, snap)

  for (var id in set.parts) {

    if (!set.parts[id].found) {
      set.parts[id].found = 0
    };
    set.parts[id].remaining = set.parts[id].found - set.parts[id].quantity;
    set.parts[id].completeness = set.parts[id].found / set.parts[id].quantity;

    // Add to totals
    set.found += set.parts[id].found;
    set.quantity += set.parts[id].quantity;
  }
  // Sort values for the set
  set.remaining = set.found - set.quantity;
  set.completeness = set.found / set.quantity;

  return set;
}

// Handle the loading and storing of set data
function load(id) {

  var prefix = 'v' + version + '_';
  if (localStorage[prefix + id]) {
    //console.log("Trying Local", id);
    return Promise.resolve(JSON.parse(LZString.decompressFromUTF16(localStorage[prefix + id])))
  } else {
    /*console.log("Trying Static", id)
    return staticset(id).then(lz => {
      let json = LZString.decompressFromUTF16(lz)
      if (typeof json === "string") {
        let set = JSON.parse(json)
        if (set) {
          console.log("Using Static", set)
          localStorage[prefix + id] = lz;
          return set
        } else {
          throw ("Invalid JSON")
        }
      } else {
        console.warn(lz)
        throw ("Invalid LZ")
      }
    }).catch((e) => {
    console.warn(e) */
    console.log("Trying Remote", id);
    return rebrickable('https://rebrickable.com/api/v3/lego/sets/' + id + '-1').then(set => {
      console.log("Using Remote", set);
      if ((id + '-1') != set.set_num) {
        return Promise.reject({
          status: 409,
          statusText: "The Set IDs dont match"
        });
      } else {
        return rebrickablepages('https://rebrickable.com/api/v3/lego/sets/' + id + '-1/parts').then(parts => {
          set.parts = parts.reduce(function (obj, part) {
            if (part.is_spare) {
              //console.info("Spare:", part)
            } else if (part.id == null) {
              console.info("No Part ID:", part)
            } else if (part.color.id == null) {
              console.info("No Color ID:", part)
            } else if (obj[part.id + '-' + part.color.id]) {
              console.info("ID already loaded", obj[part.id + '-' + part.color.id], part)
            } else {
              //Remove useless keys
              delete part.is_spare
              delete part.inv_part_id
              delete part.color.external_ids
              delete part.color.rgb
              delete part.color.is_trans
              delete part.part.external_ids
              delete part.part.print_of
              delete part.part.part_url
              delete part.num_sets

              obj[part.id + '-' + part.color.id] = part
            }
            return obj;
          }, {})

          delete set.set_url
          delete set.last_modified_dt

          localStorage[prefix + id] = LZString.compressToUTF16(JSON.stringify(set));
          return set;
        }, Promise.reject);
      }
    }, Promise.reject)
    //})
  }
}
Vue.prototype.$Load = load

// Keeps grabbing until there are no more pages
function rebrickablepages(url, results = []) {
  return rebrickable(url).then(newdata => {
    results = results.concat(newdata.results)
    if (newdata.next) {
      return rebrickablepages(newdata.next, results)
    } else {
      return results;
    }
  })
}

// Handles the Rebrickable API V3
function rebrickable(url, retry = 1) {
  if (retry > 1) console.log("Retry", retry, url)
  //console.log(url);
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url);
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.setRequestHeader('Authorization', 'key lG7VovfFg3');

    xhr.onload = function () {
      if (this.status >= 200 && this.status < 300) {
        resolve(JSON.parse(xhr.response));
      } else if (this.status == 429) {
        resolve(delay(1000 * retry).then(() => rebrickable(url, retry++)))
      } else {
        reject({
          status: this.status,
          statusText: xhr.statusText
        });
      }
    };
    xhr.onerror = function () {
      reject({
        status: this.status,
        statusText: xhr.statusText
      });
    };
    xhr.send();
  });
}

// Handles the static lz json set
function staticset(set) {
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', `/static/sets/${set}.lz`);

    xhr.onload = function () {
      if (this.status >= 200 && this.status < 300) {
        resolve(xhr.response);
      } else if (this.status == 404) {
        reject(`Cant find /static/sets/${set}.lz`)
      } else {
        reject({
          status: this.status,
          statusText: xhr.statusText
        });
      }
    };
    xhr.onerror = function () {
      reject({
        status: this.status,
        statusText: xhr.statusText
      });
    };
    xhr.send();
  });
}

function delay(ms) {
  let uid = Math.random()
  console.log(`Waiting ${ms}ms ${uid}`)
  return new Promise(resolve => setTimeout(() => {
    console.log(`Waited ${ms}ms ${uid}`)
    resolve()
  }, ms));
}



// WEBPACK FOOTER //
// ./src/main.js